<template>
    <div>
        <h5>{{ selectedType }}</h5>
        <!-- Form Body -->
        <b-form>
            <div class="d-flex justify-content-center mt-4">
                <b-button variant="success" size="sm" @click="submitForm">
                    {{ admissionformId ? "Update" : "Submit" }}
                </b-button>
                <b-button variant="danger" size="sm" class="ml-2" @click="resetForm">
                    Cancel
                </b-button>
            </div> <br><br>

            <!-- Form Name Input -->
            <b-form-group label-for="formName">
                <label for="formName" class="font-weight-bold">
                    Enquiry/Admission Form Name <span class="text-danger">*</span>
                </label>
                <b-form-input id="formName" v-model="admissionform.name" placeholder="Enter Form Name" required />
                <span class="text-danger" v-if="!$v.admissionform.name.required && $v.admissionform.name.$dirty">
                    Form Name is required!
                </span>
            </b-form-group>

            <!-- Academic Year Select -->
            <b-form-group label-for="academicYear">
                <label for="academicYear" class="font-weight-bold">
                    Academic Year <span class="text-danger">*</span>
                </label>
                <b-form-select id="academicYear" :disabled="admissionformId" v-model="admissionform.academic_year"
                    :options="academicYears" required />
                <span class="text-danger"
                    v-if="!$v.admissionform.academic_year.required && $v.admissionform.academic_year.$dirty">
                    Academic Year is required!
                </span>
            </b-form-group>

            <!-- Start Date -->
            <b-form-group class="mr-2 mb-0">
                <label class="font-weight-bold">
                    Start Date <span class="text-danger">*</span>
                </label>
                <b-form-datepicker v-model="admissionform.start_date" placeholder="Select Start Date" required
                    menu-class="w-100" class="w-100"
                    :class="{ 'form-group-error': $v.admissionform.start_date.$error }" />
                <span class="text-danger small"
                    v-if="!$v.admissionform.start_date.required && $v.admissionform.start_date.$dirty">
                    Required!
                </span>
            </b-form-group>

            <!-- End Date -->
            <b-form-group class="mb-3">
                <label class="font-weight-bold">
                    End Date <span class="text-danger">*</span>
                </label>
                <b-form-datepicker v-model="admissionform.end_date" placeholder="Select End Date" required
                    menu-class="w-100" class="w-100"
                    :class="{ 'form-group-error': $v.admissionform.end_date.$error }" />
                <span class="text-danger small"
                    v-if="!$v.admissionform.end_date.required && $v.admissionform.end_date.$dirty">
                    Required!
                </span>
            </b-form-group>
            <br>
            <!-- Bottom Buttons (Centered with Spacing) -->
            <div class="d-flex justify-content-center mt-4">
                <b-button variant="success" size="sm" @click="submitForm">
                    {{ admissionformId ? "Update" : "Submit" }}
                </b-button>
                <b-button variant="danger" size="sm" class="ml-2" @click="resetForm">
                    Cancel
                </b-button>
            </div>
        </b-form>

    </div>
</template>


<script>
import { required } from "vuelidate/lib/validators";

export default {
    props: ["selectedType", "formData"],
    async created() {
        console.log("admissionData", this.formData);
        if (this.formData) {
            this.admissionform = this.formData;
            this.admissionformId = this.formData.id;
        }
    },

    data() {
        return {
            admissionformId: null,
            admissionform: {
                id: null,
                name: "",
                academic_year: "",
                start_date: "",
                end_date: "",
            },
        };
    },

    // Form validation rules
    validations: {
        admissionform: {
            name: { required },
            academic_year: { required },
            start_date: { required },
            end_date: { required },
        },
    },

    computed: {
        // Generate academic years dynamically
        academicYears() {
            const startYear = 2019;
            const endYear = 2026;
            return Array.from({ length: endYear - startYear }, (_, i) => {
                const year1 = startYear + i;
                const year2 = (year1 + 1).toString().slice(-2); // Extract last two digits
                return `${year1}-${year2}`;
            });
        }
    },

    watch: {
        admissionData: {
            immediate: true,
            handler(newData) {
                if (newData) {
                    this.admissionform = { ...newData };
                }
            }
        }
    },

    methods: {
        // Handle form submission
        async submitForm() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            const url = this.admissionform.id
                ? `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/${this.admissionform.id}`
                : `${this.$store.getters.getAPIKey.mainAPI}/admissionforms`;

            const method = this.admissionform.id ? "put" : "post";

            await this.$axios[method](url, this.admissionform)
                .then(() => {
                    this.$toast.success("Form Submitted successfully", {
                        position: "top",
                        duration: 3000,
                    });
                })
                .catch((error) => {
                    let errortxt = error.response.data.message ?? 'Failed to Submit, please try agin';
                    this.$toast.error(errortxt, {
                        position: "top",
                        duration: 7000,
                    });
                });

            this.resetForm(); // Reset form fields
        },

        // Reset form fields and validation
        resetForm() {
            this.$v.$reset(); // Reset validation state
            this.admissionform = { name: "", academic_year: "", start_date: "", end_date: "" }; // Reset form data
            this.$emit("closeForm");
            this.$emit("reloadAdmissionFormList");
            this.formData = {};
        },
    },
};
</script>
